import { OrderBuyerModel } from '@steelbuy/ts-shared';

import { createCreateEntityDataContext } from '../../util/provider/CreateEntityDataProvider';

export const OrderBuyerCreateEntityData = createCreateEntityDataContext<OrderBuyerModel>();
